export const API_ADDRESS =
    process.env.REACT_APP_MEETINGS_API_URL ||
    (process.env.NODE_ENV === 'production'
        ? 'https://meetings-api.poroshatfilter.ir/api'
        : 'http://localhost:6003/api');

// Porosys variables
export const POROSYS_API_URL =
    process.env.REACT_APP_POROSYS_API_URL ||
    (process.env.NODE_ENV === 'production'
        ? 'https://porosys-api.poroshatfilter.ir/api/v1'
        : 'http://localhost:5001/api/v1');
export const POROSYS_CLIENT_URL =
    process.env.REACT_APP_POROSYS_CLIENT_URL ||
    (process.env.NODE_ENV === 'production' ? 'https://porosys.poroshatfilter.ir' : 'http://localhost:3000');
